export const queryKey = {
  myInfo: ['myInfo'],
  getInfiniteLikeFolders: ['getInfiniteLikeFolders'],
  getInfiniteRecentlyViewedGoods: ['getInfiniteRecentlyViewedGoods'],
  getMemberInfoQuery: ['getMemberInfoQuery'],
  cartMeta: ['cartMeta'],
  configs: ['configs'],
  proxy: (url?: string) => ['proxy', url],
  screenComponent: (
    screenName?: string,
    componentId?: number,
    paramValue?: string | null,
    queryName?: string,
    extraParams?: Record<string, string | null>,
  ) => [
    'atomicScreenComponent',
    screenName,
    componentId,
    paramValue,
    queryName,
    extraParams,
  ],
} as const;
